import { render, staticRenderFns } from "./SharedStudentInfo.vue?vue&type=template&id=1d56b2ee&scoped=true&"
import script from "./SharedStudentInfo.vue?vue&type=script&lang=js&"
export * from "./SharedStudentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d56b2ee",
  null
  
)

export default component.exports